import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

interface Supplier {
  id: string;
  name: string;
  product_count: number;
}

export function CatalogPage() {
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function load() {
      const { data, error } = await supabase
        .from('gift_suppliers')
        .select('id, name, gift_products(count)')
        .order('name');
      if (error) {
        setError(error.message);
      } else {
        setSuppliers(
          (data ?? []).map((s) => ({
            id: s.id,
            name: s.name,
            product_count:
              (s.gift_products as unknown as { count: number }[] | null)?.[0]?.count ?? 0,
          }))
        );
      }
      setLoading(false);
    }
    void load();
  }, []);

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold text-bmade-950 dark:text-white">Catalogus</h1>
        <p className="text-sm text-bmade-600 dark:text-bmade-400">
          Leveranciers en producten beschikbaar voor pakketten.
        </p>
      </header>

      {error && (
        <div className="rounded-md border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-700 dark:border-red-500/40 dark:bg-red-500/10 dark:text-red-300">
          {error}
        </div>
      )}

      {loading ? (
        <div className="text-sm text-bmade-500">Laden...</div>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {suppliers.map((s) => (
            <div
              key={s.id}
              className="rounded-xl border border-bmade-200 bg-white p-4 transition-colors hover:border-bmade-300 hover:shadow-sm dark:border-bmade-800 dark:bg-bmade-900/60 dark:hover:border-bmade-700"
            >
              <div className="text-base font-semibold text-bmade-950 dark:text-white">{s.name}</div>
              <div className="mt-1 text-xs text-bmade-500 dark:text-bmade-400">
                {s.product_count} producten
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
